import { SitecoreRouteContainer } from '@eneco/containers';
import Layout from '@eneco/layouts/main';
import { getSSP } from '@eneco/next/server';
import type { NextCatchAllRoute } from '@eneco/next/server';

import { countryCode, businessUnit, label, name, transformFunctions } from '../config';
import components from '../sitecoreComponents';

const CatchAllRoute: NextCatchAllRoute = ({ clientIdEncoded, dataLayerEvents, i18n, layoutData, nbaData, pageViewProfile, path, platformHint }) => (
  <SitecoreRouteContainer
    businessUnit={businessUnit}
    clientIdEncoded={clientIdEncoded}
    components={components}
    dataLayerEvents={dataLayerEvents}
    i18n={i18n}
    label={label}
    layoutData={layoutData}
    name={name}
    nbaData={nbaData}
    pageViewProfile={pageViewProfile}
    path={path}
    platformHint={platformHint}>
    <Layout />
  </SitecoreRouteContainer>
);

export default CatchAllRoute;

export const getServerSideProps = getSSP({ businessUnit, countryCode, label, transformFunctions });
